// extracted by mini-css-extract-plugin
module.exports = {"editingSpacing":"html-content_editingSpacing__TV8tm","content":"html-content_content__JFUur","pageRichText":"html-content_pageRichText__n_LC1"};